import React from "react";
import { BrowserRouter, Routes, Route } from 'react-router-dom';
import Home from "../View/Home/Home";
import Nav from "../Components/Nav/Nav";
import Contact from "../View/contact/Contact";
import Footer from "../Components/Footer/Footer";
import Factory from "../View/Factory/Factory";
import About from "../View/Aboutus/Aboutus";
import Collection from "../View/Collection/Collection";
import Maintenance from "../View/Maintenance/Maintenance";
import BrochureDigital from "../View/BrochureDigital/BrochureDigital";
import WhatsAppFloat from "../Components/WhatsAppFloat/WhatsAppFloat";


function Router() {
    return (
        <BrowserRouter>
            <Nav />
            <Routes>
                <Route index element={<Home />} />
                <Route path="/Inicio" element={<Home />} />
                <Route path="/Contactanos" element={<Contact />} />
                <Route path="/Fabrica" element={<Factory />} />
                <Route path="/Sobre_nosotros" element={<About />} />
                <Route path="/Collecciones" element={<Collection />} />
                <Route path="/Mantenimiento" element={<Maintenance />} />
                <Route path="/BrochureDigital" element={<BrochureDigital />} />
            </Routes>
            <Footer />
            <WhatsAppFloat />
        </BrowserRouter>
    );
}

export default Router;
